/**
 * Main site controller, typically used to manage items that are common across multiple views
 */
app.main = (function() {
    'use strict';
    var languageData = null,
        langFallback = false,   // set to null to re-enable en-us fallback
        cookieData = {},
        profile = null,
        cultures = null,
        ranks = [
            'rank_distributor',
            'rank_star',
            'rank_senior_star',
            'rank_executive',
            'rank_silver',
            'rank_gold',
            'rank_platinum',
            'rank_diamond',
            'rank_crown_diamond',
            'rank_royal_crown_diamond'
        ],
        themes = [
            'Theme 1',
            'Theme 2',
            'Theme 3',
            'Theme 4',
            'Theme 5'
        ],
        loaded = false,
        cartLoaded = false,
        settings = false,
        localOverride = false,
        activeProducts = null,
        activeProductsTotal = null,

        self = {

        /**
         * Called on page load
         */
        init: function() {
            Handlebars.registerPartial('partial-signed-in', $('#template-partial-signed-in').html());
            Handlebars.registerPartial('partial-social-links', $('#template-partial-social-links').html());

            Handlebars.registerHelper('currency', function(num, hideLabel) {
                return app.global.currency(num, false, hideLabel === true);
            });

            // basic math for pv formatting, expects an integer like 1450 etc.
            Handlebars.registerHelper('calcPV', function(num) {
                return num / 100;
            });

            // fomat phone numbers
            Handlebars.registerHelper('formatPhoneNumber', function(display_phone) {
                if (!display_phone) {
                    return;
                }

                var number = libphonenumber.parsePhoneNumberFromString(display_phone, app.main.getProfile().country.toUpperCase());

                if (number) {
                    // if (app.main.getProfile().country !== app.main.getCountryCode()) {
                    //     return number.formatInternational();
                    // }

                    return number.formatInternational();
                }

                return display_phone;
            });

            // add logical operators
            Handlebars.registerHelper('ifCond', function (v1, operator, v2, options) {

                switch (operator) {
                    case '==':
                        return (v1 == v2) ? options.fn(this) : options.inverse(this);
                    case '===':
                        return (v1 === v2) ? options.fn(this) : options.inverse(this);
                    case '!=':
                        return (v1 != v2) ? options.fn(this) : options.inverse(this);
                    case '!==':
                        return (v1 !== v2) ? options.fn(this) : options.inverse(this);
                    case '<':
                        return (v1 < v2) ? options.fn(this) : options.inverse(this);
                    case '<=':
                        return (v1 <= v2) ? options.fn(this) : options.inverse(this);
                    case '>':
                        return (v1 > v2) ? options.fn(this) : options.inverse(this);
                    case '>=':
                        return (v1 >= v2) ? options.fn(this) : options.inverse(this);
                    case '&&':
                        return (v1 && v2) ? options.fn(this) : options.inverse(this);
                    case '||':
                        return (v1 || v2) ? options.fn(this) : options.inverse(this);
                    default:
                        return options.inverse(this);
                }
            });

            // pass the query string to the template when linking to YL.com
            Handlebars.registerHelper('getMemberString', function() {
                return self.getMemberString();
            });

            Handlebars.registerHelper('isOnSale', function(product, options) {
                return app.products.isOnSale(product) ? options.fn(this) : options.inverse(this);
            });

            Handlebars.registerHelper('selected', function(val, match) {
                return val == match ? ' selected' : '';
            });

            Handlebars.registerHelper('helpTip', function(key) {
                return '<span class="help-tip" data-key="'+ key +'">?</span>';
            });

            Handlebars.registerHelper('replace', function(str, inject) {
                if (str) {
                    var replace = str.replace(/%s/g, inject);
                    return new Handlebars.SafeString(replace);
                } else {
                    return '';
                }
            });

            Handlebars.registerHelper('truncate', function(str) {
                var maxLength = 250,
                    regexp = /<[\/\w]+>/g;

                // strip out any html formatting
                str = str.replace(regexp, '');

                // truncate string length if necessary
                if (str && str.length > maxLength) {
                    str = str.substring(0, maxLength);
                    str = str.substring(0, str.lastIndexOf(' ')) +'…';
                }

                return str;
            });

            Handlebars.registerHelper('nl2br', function(str) {
                str = Handlebars.Utils.escapeExpression(str);
                str = str.replace(/(\r\n|\n|\r)/gm, '<br>');
                return new Handlebars.SafeString(str);
            });

            // message listener for preview mode and contact form
            // todo: can this be safely moved to app.pws?
            $(window).on('message', function(e) {
                app.pws.messageHandler(e.originalEvent.data);
            });

            // defer until data injection from parent for preview
            // only call this the first time when preview is still false
            if (app.pws.inIframe() && app.pws.isPreview() === false) {
                // special case for tracking after a successful VO enrollment when this is loaded in an iframe but is not in preview mode
                if (document.referrer.indexOf('youngliving.com') < 0) {
                    app.pws.postMessage('preview-ready');
                    return;
                }
            }

            $(window).on('hashchange', function(e) {
                e.preventDefault();
                self.checkHash();
            });

            var cookie = app.cookie.get();
            if (cookie) {
                cookieData = JSON.parse(cookie);
            }

            app.cookie.check();

            // use a default profile.json if the url is not defined
            if (profileURL == 'PROFILE_JSON_URL' || profileURL == undefined) {
                profileURL = 'https://s3.amazonaws.com/assets.ylpwsdev.com/profiles/tbigtsmall.json';
                // profileURL = 'https://s3.amazonaws.com/assets.ylpwsdev.com/profiles/preview-ca.json';
                // profileURL = 'https://s3.amazonaws.com/assets.ylpwsdev.com/profiles/tbig5tsmall5-aussie.json';
            }

            $.getJSON(profileURL + cb, function(data) {
                profile = data;

                // only us and ca are valid, so change any others to en-us
                if (!['us', 'ca'].includes(profile.country)) {
                    console.log('Setting profile to en-us');
                    profile.country = 'us';
                    profile.culture = 'en-us';
                }

                // is this site enabled or unsupported?
                if (profile.site_enabled !== true || profile.supported_market !== true) {
                    window.location.replace('/error');
                    return;
                }

                // is this site not active?
                if (profile.site_active !== true) {
                    window.location.replace(window.location.origin +'/');
                }

                if (!profile.profile_image) {
                    profile.profile_image = window.location.origin +'/img/profile-default.jpg';

                } else {
                    profile.profile_image = assetURL[mode] + profile.profile_image;
                }

                // we have profile data, now load everything else
                if (profile.culture == undefined) {
                    profile.culture = 'en-us';
                    profile.country = 'us';
                }

                // for pws page later, use default social urls if all are empty
                var socialFields = ['social_blog', 'social_youtube', 'social_facebook', 'social_twitter', 'social_pinterest', 'social_instagram'],
                    found = false;

                // if all profile fields are blank then use YL defaults
                for (var i=0; i<socialFields.length; i++) {
                    if (profile[socialFields[i]]) {
                        found = true;
                        break;
                    }
                }

                // use defaults if no social media values were found
                if (found === false) {
                    profile.social_blog = 'https://www.youngliving.com/blog/';
                    profile.social_youtube = 'https://www.youtube.com/user/youngliving007';
                    profile.social_facebook = 'YoungLiving';
                    profile.social_twitter = 'youngliving';
                    profile.social_pinterest = 'youngliving';
                    profile.social_instagram = 'youngliving';
                }

                // sort events by date
                self.sort(profile.events, 'start_date_time');

                app.productcard.init();
                app.productsearch.init('pws');
                self.loadLanguageData(self.getCurrentCulture());

            }).fail(function(e) {
                // profile json didn't load or was not found, redirect to error page
                window.location.replace('/error');
            });
        },

        /**
         * Helper function to clean up the hash if needed
         */
        getHash: function() {
            // first strip away any extraneous query string data
            var url = window.location.href,
                pieces = [];

            if (url.indexOf('?') > -1 && url.indexOf('share=') < 0) {
                pieces = url.split('?');
                var memberURL = pieces[0];

                // be sure to account for an existing hash (probably a bundle)
                if (pieces[1].indexOf('#') > -1) {
                    memberURL += '#'+ pieces[1].split('#')[1];
                }

                window.history.replaceState({}, document.title, memberURL);
            }

            // enroll is now build
            if (window.location.hash.indexOf('#enroll') > -1) {
                 window.location.hash = window.location.hash.replace('#enroll', '#build');
            }

            var hash = window.location.hash.substr(1).toLowerCase();

            // do another round of filtering in case another query string is after the hash
            if (hash.indexOf('?') > -1) {
                pieces = hash.split('?');
                hash = pieces[0];
                window.location.hash = hash;
            }

            // remove initial slash if it exists
            if (hash.substr(0, 1) == '/') {
                hash = hash.substr(1);
            }


            return hash;
        },

        /**
         * Check the URL hash value and process accordingly
         */
        checkHash: function() {
            var hash = self.getHash(),
                cookie,
                cookieData;

            app.page.addHistory();

            // special 'scrolling' hashes
            if (['my-products', 'my-events', 'contact-me'].includes(hash)) {
                if (document.getElementById($(this).data('scrollto'))) {
                    self.scrollTo(hash);
                    return;

                } else {
                    cookie = app.cookie.get();
                    cookieData = { 'scrollTo': '' };

                    if (cookie) {
                        cookieData = JSON.parse(cookie);
                    }

                    cookieData.scrollTo = hash;
                    app.cookie.set(JSON.stringify(cookieData));
                    app.page.loadPage('');
                    window.scrollTo(0, 0);
                    return;
                }
            }

            self.pageView();
            app.page.setID(hash);
            self.hideHeaderRight(false);

            var pieces = decodeURIComponent(hash).split('/');
            if (['ewm', 'build', 'bwm'].includes(pieces[0])) {
                hash = pieces[0];
            }

            app.location.applyRebrand();

            // reset in case of previously hidden nav
            self.toggleNavigation(true);

            switch (hash) {
                // for testing only
                case 'login':
                case 'signin':
                    self.signIn();
                    break;

                case 'logout':
                case 'signout':
                    if (self.getSettings().skavaEnabled) {
                        self.resetShopping(function() {
                            window.location.href = self.getAdminPath() +'#signout';
                        });

                    } else {
                        window.location.href = self.getAdminPath() +'#signout';
                    }
                    break;

                // todo: deprecated - remove later
                case 'signup':
                    if (mode !== 'local') {
                        app.page.showLoader();

                        // store url for callback
                        app.cookie.set(window.location.origin + window.location.pathname +'#resume', 'myyl_redirect', 0.25);
                        var url = app.skava.getOpenIdUrl() +'&simple_view=true&initial_screen=signup&referral_id='+ app.main.getProfile().member_id +'&locale='+ self.getYLCulture();
                        window.location.replace(url);
                        return false;

                    } else {
                        window.location.href = 'pws.html';
                    }
                    break;

                case 'resume':
                    app.page.showLoader();

                    // todo: can this be replaced with app.skava.messageHandler('login-success');
                    app.skava.refreshSession(function(err) {
                        console.log('Refreshing session...');

                        if (err) {
                            console.log('session refresh failed');
                            console.log(err);
                        }

                        // set to true in case of a preslected cart
                        // so it won't redirect to the review process after loading
                        app.enroll.setAlreadySelected(true);

                        var resumeHash = app.cookie.get('myyl_resume');
                        console.log('resume hash: '+ resumeHash);

                        if (resumeHash) {
                            console.log('Proceed to checkout...');
                            window.location.hash = resumeHash;

                        } else {
                            window.location.hash = "#build/info";
                        }
                    });
                    break;

                // for testing only
                case 'showkeys':
                    self.showLangKeys(true);
                    break;

                // for testing only
                case 'hidekeys':
                    self.showLangKeys(false);
                    break;

                case 'cart':
                    app.main.track('CART', 'Review');
                    self.hideHeaderRight(true);
                    app.pws.init(true);
                    break;
                case 'checkout':
                case 'checkout/account':
                case 'checkout/new':
                case 'checkout/signup':
                case 'checkout/guest':
                    app.main.track('CART', 'Account Intention');
                    var currentMode = app.skava.getShoppingMode(app.skava.CART_SHOPPING_MODE);
                    if (currentMode === app.skava.CART_SHOPPING_MODE) {
                        self.hideHeaderRight(true);
                        app.pws.init(true);

                    } else {
                        $('#page #enrollment').html('');
                        app.enroll.init('checkout');
                    }
                    break;

                case '/':
                case '':
                case 'home':    // deprecated
                    app.skava.setShoppingMode(app.skava.CART_SHOPPING_MODE);
                    app.pws.init();
                    break;

                // custom enrollment
                case 'build':
                    app.skava.setShoppingMode(app.skava.BWM_SHOPPING_MODE);
                    self.hideHeaderRight(true);

                    if (self.getSettings().skavaEnabled && !pieces[1]) {
                        // build endpoint without a step is deprecated for skava regions
                        app.page.loadPage('');
                        return;
                    }

                    // a 3rd piece? that's the package name to help with url copy+paste
                    if (pieces[2]) {
                        if (!app.enroll.setRequestedSlug(pieces[2])) {
                            // bwm refresh is happening, stop
                            return false;
                        }
                    }


                    if (pieces[1]) {
                        app.enroll.init(pieces[1]);

                    } else {
                        app.enroll.init('start');
                    }
                    break;

                case 'ewm':
                case 'bwm':
                    // clear any previously saved data
                    app.enroll.reset();

                    // if targeted enrollment is disabled, redirect to standard enrollment
                    if (!settings.targeted_enrollment_enabled) {
                        app.page.loadPage('build', true);
                        return;
                    }

                    // special case for international bundle
                    var codes = self.parseIntlHash();

                    if (codes) {
                        if (codes.culture != self.getCurrentCulture()) {
                            cookie = app.cookie.get();
                            cookieData = {};

                            if (cookie) {
                                cookieData = JSON.parse(cookie);
                            }

                            cookieData.country = codes.country;
                            cookieData.culture = codes.culture;
                            app.cookie.set(JSON.stringify(cookieData));

                            self.loadLanguageData(codes.culture);
                            return;
                        }
                    }

                    if (self.getSettings().skavaEnabled) {
                        // also clear regular cart and delete any existing skava cart
                        app.cart.clear();
                        // app.skava.deleteCart();
                        app.skava.setShoppingMode(app.skava.BWM_SHOPPING_MODE);
                    }

                    if (pieces[1]) {
                        self.hideHeaderRight(true);

                        if (pieces[1].indexOf('international') > -1 || pieces[1] == 'default') {
                            if (codes) {
                                app.enroll.setIntlBundle(codes);
                            }

                            if (self.getSettings().skavaEnabled) {
                                app.page.loadPage('build/subscription', true);

                            } else {
                                app.page.loadPage('build', true);
                            }

                        } else {
                            // pass the slug value to the enroll module to load the custom package
                            app.enroll.setRequestedSlug(pieces[1]);
                            app.enroll.init('start', pieces[1]);
                        }

                    } else {
                        // no slug? load standard enrollment
                        app.page.loadPage('build');
                    }

                    break;

                case 'faq':
                    window.location.replace('/#faq');
                break;

                case 'support':
                    app.modal.support.init();
                break;

                default:
                    try {
                        $('.header-right').show();
                        app.page[hash].init();

                    } catch(e) {
                        console.error(e);
                        app.page.error.init();
                    }
                break;
            }
        },

        signIn: function(noReset) {
            app.ga.event('login', { method: 'Header' });

            function skavaLogin() {
                if (mode !== 'local') {
                    // store url for callback
                    if (self.getHash().indexOf('signin') > -1) {
                        // never store signin url to avoid redirect loop
                        app.cookie.set(window.location.origin + window.location.pathname, 'myyl_redirect', 0.25);

                    } else {
                        app.cookie.set(window.location.href, 'myyl_redirect', 0.25);
                    }

                    var url = app.skava.getOpenIdUrl() +'&referral_id='+ app.main.getProfile().member_id +'&locale='+ app.main.getYLCulture();
                    window.location.replace(url);
                    return false;

                } else {
                    window.location.href = 'pws.html';
                }
            }

            if (self.getSettings().skavaEnabled) {
                if (noReset) {
                    skavaLogin();

                } else {
                    self.resetShopping(skavaLogin);
                }

            } else {
                if (mode !== 'local') {
                    window.location.href = '/admin';

                } else {
                    window.location.href = 'pws.html';
                }
            }
        },

        /**
         * In case of a preselected cart, hide navigation elements in header/footer
         */
        toggleNavigation: function(enable) {
            var elements = [
                    '.member-info span a',
                    'footer .inner ul'
                ],
                disable = '#nav_logo, #ga-footer-logo, header nav, #btn-menu, .social-links';

            if (enable === true) {
                elements.forEach(function(elt) {
                    $(elt).show();
                });

                $(disable).removeClass('is-disabled');

            } else {
                elements.forEach(function(elt) {
                    $(elt).hide();
                });

                $(disable).addClass('is-disabled');

            }
        },

        /**
         * Show/hide top right header when entering or leaving enrollment
         */
        hideHeaderRight: function(hide) {
            var $elt = $('.header-right');
            var $inner = $('#inner-right');

            if (hide === true) {
                $elt.hide();
                return;
            }

            if (hide === false) {
                $elt.show();
                // in case unified shopping hid inner links
                $inner.show();
                return;
            }
        },

        /**
         * Load the language profile. Default is profile language, can be overridden by sending l18n string (en-us, de-de, etc.)
         * Optionally can ALWAYS load en-us before loading any other localized messages. This way english can be used if keys are missing
         */
        loadLanguageData: function(culture) {
            if (culture === undefined) {
                culture = self.getCurrentCulture();
            }

            if (culture !== 'en-us' && langFallback === null) {
                // load en-us
                console.log('loading language fallback');
                $.getJSON(assetURL[mode] +'json/en-us/public-messages.json', function(data) {
                    langFallback = data;
                    // recursion
                    self.loadLanguageData(culture);
                });
                return false;
            }

            var randomCB = Math.floor(Math.random() * 1000000000);

            $.when(
                $.getJSON(assetURL[mode] +'json/'+ culture +'/public-messages.json'+ cb),
                $.getJSON(assetURL[mode] +'json/countries.json'),
                $.getJSON(assetURL[mode] +'json/settings.json?v='+ randomCB)

            ).done(function(publicLang, countries, config) {
                settings = config[0];

                // cultures = countries[0];

                // // add eu as a country type
                // cultures.eu = {
                //     "name": "European Union",
                //     "languages": [
                //     {
                //         "code": "en-eu",
                //         "language": "English (European Union)"
                //     }],
                //     "default_language":
                //     {
                //         "code": "en-eu",
                //         "language": "English (European Union)"
                //     }
                // };

                // ignore all but us and ca
                cultures = {
                    ca: countries[0].ca,
                    us: countries[0].us
                };

                for (var code in cultures) {
                    var i = cultures[code].languages.length;

                    // if profile is not in a skava enabled country,
                    // then remove skava enabled countries from language chooser
                    /* allow en-us, etc.
                    if (!skavaEnabledCountries.includes(self.getProfile().country)) {
                        if (skavaEnabledCountries.includes(code)) {
                            console.log('disabling '+ code);
                            cultures[code].disabled = true;
                        }
                    }
                    */

                    if (i > 1) {
                        while (i--) {
                            if (cultures[code].default_language.code == cultures[code].languages[i].code) {
                                // found the default lang in the list of langs, move it to the front of the array
                                cultures[code].languages.splice(i, 1);
                                cultures[code].languages.unshift(cultures[code].default_language);
                                break;
                            }
                        }
                    }
                }

                // pass location/language data to the location module
                app.location.setLocations(cultures);

                // empty default products in case localized settings.json doesn't exist
                settings.default_product_ids = "";

                // this isn't part of the global settings, default to true globally
                settings.tax_inclusive_pricing_enabled = true;

                // used for non-skava regions, enable queueit redirect functionality during checkout/enrollment
                settings.queueit_enabled = false;
                console.log('queueit_enabled: '+ settings.queueit_enabled);

                // if langFallback was previously loaded, merge the two language objects into one,
                // which should fill in any missing keys with default en-us values
                if (langFallback !== null) {
                    languageData = $.extend({}, langFallback, publicLang[0]);
                    // languageData = publicLang[0];
                    // console.log('Language files merged, '+ (Object.keys(langFallback).length - Object.keys(publicLang[0]).length) +' keys missing defaulting to en-us');

                } else {
                    languageData = publicLang[0];
                }

                if (languageData.event_disclaimer) {
                    languageData.event_disclaimer = app.main.strReplace(app.main.lang('event_disclaimer'), cultures[self.getProfile().country].name);
                }

                // makes testing with other culture codes easier
                if (mode === 'local' && culture != 'en-us' && localOverride === true) {
                    console.log('use local override');
                    languageData = langFallback;
                }

                // special case for FR to add a space at the end of certain keys
                if (['fr'].includes(app.main.getCountryCode())) {
                    ['product_item_number', 'product_retail_price', 'product_whsl_price', 'ce_pv'].forEach(function(key) {
                        if (languageData[key]) {
                            languageData[key] += ' ';
                        }
                    });
                }

                try {
                    var replaceLangKeys = app.cookie.get('myyl_show_lang_keys');

                    // for displaying lang key instead of content
                    if (replaceLangKeys) {
                        for (var key in languageData) {
                            if (languageData.hasOwnProperty(key)) {
                                languageData[key] = key;
                            }
                        }
                    }

                } catch(err) {
                    // do nothing
                }

                // regional settings
                $.getJSON(assetURL[mode] +'json/'+ culture +'/settings.json')
                    .done(function(localConfig) {
                        // This will loop through all keys in localConfig and override main settings to false
                        // where applicable. Unless any exceptions come up, this should work fine for
                        // any new boolean keys that might be added.
                        Object.keys(localConfig).forEach(function(key) {
                            // if a global setting is false, local settings shouldn't override
                            if (settings[key] === false) {
                                return;
                            }

                            if (localConfig[key] === false) {
                                settings[key] = false;

                            } else {
                                settings[key] = localConfig[key];
                            }
                        });

                        // special case for dcp_enabled
                        if (localConfig.dcp_enabled === true) {
                            settings.skavaEnabled = true;
                            settings.product_card_enabled = true;
                            settings.global_search_enabled = true;
                        }

                        if (!skavaEnabledCountries.includes(self.getCountryCode())) {
                            settings.skavaEnabled = false;
                            settings.rebrand_enabled = false;
                        }

                        if (app.main.lang('setting_disable_products') && !settings.skavaEnabled) {
                            settings.disableProducts = true;
                        }

                        if (app.main.lang('setting_disable_kits')) {
                            settings.disableKits = true;

                        } else {
                            settings.disableKits = false;
                        }

                        // unified shopping
                        if (settings.unified_shopping_countries) {
                            var country_ids = settings.unified_shopping_countries.split(',');

                            if (country_ids.includes(self.getCountryCode())) {
                                settings.unified_shopping_enabled = true;
                                settings.rebrand_enabled = true;
                            }
                        }

                        // disable enrollment if international markets are disabled
                        if (!settings.skavaEnabled && !settings.international_shopping_enabled) {
                            settings.disableProducts = true;
                            settings.custom_enrollment_enabled = false;
                            settings.targeted_enrollment_enabled = false;
                        }

                        // which countries are allowed to see attribution report link in the admin menu
                        if (settings.attribution_countries) {
                            var country_ids = settings.attribution_countries.split(',');

                            if (country_ids.includes(self.getProfile().country)) {
                                settings.attributionEnabled = true;
                            }
                        }

                        // which countries have the mycomms (prospects tool) enabled
                        if (settings.mycomms_countries) {
                            var country_ids = settings.mycomms_countries.split(',');

                            if (country_ids.includes(self.getCountryCode())) {
                                settings.mycomms_enabled = true;
                            }
                        }
                    })

                    .fail(function() {
                        console.log('Localized settings.json for '+ culture +' not found. This is probably fine.');
                    })

                    .always(function() {
                        self.addTempLangKeys();
                        $('html').attr('lang', culture.split('-')[0]);

                        if (app.main.getSettings().skavaEnabled) {
                            // app.skava.getSubscriptions(function(res) {
                            app.skava.setUpSession(
                                function(res) {
                                    self.render(culture);
                                    app.pws.postMessage('preview-rendered');
                                }
                            );

                        } else {
                            self.render(culture);
                            app.pws.postMessage('preview-rendered');
                        }
                    });
            });
        },

        /**
         * When adding new features, use this to add temporary language keys before adding them to the back-end
         * Remove once all translations have been properly added to the back-end
         */
        addTempLangKeys: function() {
            //if (mode == 'test' || mode == 'live') return;

            var tempKeys = {
                // key: 'value'
            };

            languageData = $.extend(tempKeys, languageData);
        },

        /**
         * Render common elements like the header/footer
         */
        render: function(culture) {
            profile.member_rank_label = app.main.lang(ranks[parseInt(profile.member_rank, 10)]);
            profile.yl_culture = app.main.getYLCulture();
            profile.yl_lang = app.main.getLanguageCode();
            profile.yl_country = app.main.getCountryCode().toUpperCase();

            // mutate products -> string of numbers to collection
            if (profile.selected_product_ids) {
                activeProducts = profile.selected_product_ids.split(',').map(Number);
                activeProductsTotal = activeProducts.length;
            }

            var gaData = {
                'profile': profile.member_id,
                'selected_theme_label': themes[parseInt(profile.selected_theme, 10)],
                'country': profile.country,
                'culture': profile.culture,
                'ce_enabled': profile.custom_enrollment_enabled,
                'active_products': activeProducts,
                'active_theme': profile.selected_theme,
                'member_rank': profile.member_rank,
                'member_rank_label': profile.member_rank_label
            };

            $.getJSON(assetURL[mode] +'json/segmentation/'+ profile.member_id +'.json')
                .done(function(result) {
                    if (result) {
                        gaData['14'] = result.site_active;
                    }
                })
                .always(function() {
                    // send to GA
                    app.ga.pushData(gaData);
                });

            var now = new Date();
            languageData.footer_copyright = self.strReplace(self.lang('footer_copyright'), now.getFullYear());

            var data = {
                profile: profile,
                lang: languageData,
                cultures: self.getCultures(),
                currentCulture: app.main.getCurrentCulture(),
                become_member_url: self.getEnrollURL(),
                enrollmentEnabled: self.checkCustomEnrollmentEnabled(),
                languageCode: self.getCurrentCulture().split('-')[0],
                countryCode: self.getCountryCode(),
                memberType: app.global.getMemberType(),
                adminPath: self.getAdminPath(),
                preview: app.pws.isPreview(),
                ceoEnabled: ['au', 'nz'].includes(self.getCountryCode()) ? true : false
            };

            $('#header').html(self.getTemplate('header', data));
            $('#footer').html(self.getTemplate('footer', data));

            $('.link-signin').on('click', function(e) {
                e.preventDefault();
                // login without reset
                self.signIn(true);
            });

            $('#link-support').on('click', function(e) {
                e.preventDefault();
                app.modal.support.init();
            });

            app.page.initGlobalAlerts();
            app.location.init();

            // Show cookie accept/deny popup, unless in preview mode
            if (app.cookie.acceptCookies() !== true && app.pws.isPreview() !== true) {
                app.message.alert({
                    type: 'info',
                    id: 'accept-cookies',
                    position: 'bottom',
                    message: app.main.getTemplate('cookie-alert', { content: app.main.strReplace(app.main.lang('cookie_alert_copy'), '#cookies') }),
                    callback: function() {
                        app.cookie.acceptCookies(true);
                    }
                });
            }

            $('#btn-menu').on('click', function(e) {
                e.preventDefault();
                self.toggleNav();
            });

            // only activate admin menu if a user type is > 0
            if (app.global.getMemberType()) {
                $('.admin-menu').on('mouseover', function(e) {
                    $(this).addClass('is-active');

                    // var pos = $(this).position();
                    // $('.admin-menu ul').css({
                    //     top: Math.round(pos.top + $(this).height()),
                    //     right: Math.round(pos.left - 25) // minus padding-left
                    // });
                });

                $('.admin-menu').on('mouseout', function(e) {
                    $(this).removeClass('is-active');
                });

                $('.admin-menu a:first-child').on('click', function(e) {
                    if ($(this).hasClass('toggle')) {
                        e.preventDefault();
                    }
                    $('.admin-menu').toggleClass('is-active');
                });
            }

            // close nav if clicking anywhere
            $('#page, header nav').on('click', function() {
                if ($('header nav').hasClass('is-active')) {
                    self.toggleNav('close');
                }
            });

            if (!app.main.getSettings().skavaEnabled) {
                // add iframe for Queue-it cookie if required
                if (['live-disabled'].includes(mode)) {
                    var page = 'en_ca/company/media/news/sustainable-energy-innovations-at-highland-flats-distillery';
                    app.global.loadIframe(ylURL[mode] + page, 'yl-iframe-queueit');
                }
            }

            // add iframe for referralId localStorage check
            if (['dev', 'test', 'live'].includes(mode)) {
                var page = ylURL[mode] +'myyl/?referralId=';
                app.global.loadIframe(page + app.main.getProfile().member_id, 'yl-iframe-referral');
            }

            // check for mycomms cookie and auto-open if needed
            setTimeout(app.modal.mycomms.init, 5000);

            $('#link-mycomms').on('click', function(e) {
                e.preventDefault();
                app.modal.mycomms.open();
            });

            // app.productsearch.enable();
            self.setEnrollCheck();
            self.checkHash();
        },

        /**
         * Open/close the mobile nav menu
         */
        toggleNav: function(force) {
            if ($('header nav').hasClass('is-active') || force == 'close') {
                $('header nav, #btn-menu').removeClass('is-active');

            } else {
                $('header nav, #btn-menu').addClass('is-active');
            }
        },

        /**
         * Return the loaded profile
         */
        getProfile: function() {
            if (settings.contact_form_enabled === false) {
                profile.contact_enabled = false;
            }
            return profile;
        },

        /**
         * For preview mode, this sets the profile
         */
        setProfile: function(data) {
            profile = data;
        },

        /**
         * Helper to return a single item in languageData
         */
        lang: function(key) {
            // return '[key: '+ key +']';

            try {
                return languageData[key];

            } catch(e) {
                return '';
            }
        },

        /**
         * Return the loaded language data
         */
        getLanguageData: function() {
            return languageData;
        },

        /**
         * Return settings
         */
        getSettings: function() {
            return settings;
        },

        /**
         * Return the current culture code
         */
        getCurrentCulture: function(opts) {
            if (!opts) {
                opts = {};
            }
            opts.filter = opts.filter || false;

            // refresh cookie data in case of language change
            var cookie = app.cookie.get();
            if (cookie) {
                cookieData = JSON.parse(cookie);
            }

            // clear cookie when in preview mode
            if (app.pws.isPreview()) {
                app.cookie.clear();
                cookieData = {};
            }

            // if previously saved member id doesn't match current member id, reset
            if (cookieData.memberID != app.main.getProfile().member_id) {
                // reset the cookie with only member id
                cookieData = {
                    memberID: app.main.getProfile().member_id
                };
                app.cookie.set(JSON.stringify(cookieData));
            }

            var culture;

            if (cookieData.culture) {
                culture = cookieData.culture;

            } else if (profile.culture) {
                culture = profile.culture;

            } else {
                culture = 'en-us';
            }

            // temp EU fix - filters certain culture codes to match what VO expects
            if (opts.filter === true) {

                var countryCode = app.location.getCurrentLocation();
                var languageCode = app.location.getCurrentLanguage().code.substring(0, 2);

                if (countryCode == 'de' || countryCode == 'at' || countryCode == 'se' || countryCode == 'ch') {

                    switch (countryCode) {
                    case 'de':
                        culture = 'de-de';
                    break;
                    case 'at':
                        culture = 'de-at';
                    break;
                    case 'se':
                        culture = 'sv-se';
                    break;
                    case 'ch':
                        culture = 'de-de';
                    break;
                    }

                }

                else {
                    if (languageCode == 'de' && countryCode != 'de' && countryCode != 'at' ||
                        languageCode == 'sv' && countryCode != 'se') {
                        culture = 'en-eu';
                    }
                }

                // console.log('country '+ app.location.getCurrentLocation() +' filtered to: '+ culture);
            }

            return culture;
        },

        /**
         * Get country code from the current country or profile culture, used with shopping cart
         */
        getCountryCode: function() {
            var cookie = app.cookie.get();
            if (cookie) {
                cookieData = JSON.parse(cookie);
            }

            if (cookieData) {
                if (cookieData.country) {
                    return cookieData.country;
                }
            }
            return profile.country;
        },

        /**
         * Get language code from the current culture, used with shopping cart
         */
        getLanguageCode: function(lowercase) {
            var code = self.getCurrentCulture().split('-')[0];

            if (lowercase !== true) {
                code = code.toUpperCase();
            }

            return code;
        },

        /**
         * Parse the special international hash 'bwm/international_en-us' etc
         */
        parseIntlHash: function() {
            try {
                if (self.getHash().indexOf('international') > -1) {
                    var pieces = self.getHash().split('_');
                    var codes = pieces[1].split('-');

                    var obj = {
                        culture: pieces[1],
                        language: codes[0],
                        country: codes[1]
                    };

                    return obj;
                }

            } catch (err) {
                console.error(err);
            }

            return false;
        },

        /**
         * When switching language, use this to find it in the cultures array
         */
        findCultureByCode: function(code) {
            var cultures = self.getCultures();
            // profile culture doesn't support language switching
            if (!cultures) return;

            for (var i=0; i<cultures.length; i++) {
                if (cultures[i].code == code) {
                    return cultures[i];
                    //break;
                }
            }
            return false;
        },

        /**
         * Use app.ga.track instead
         * Analytics
         * ga('send', 'event', [eventCategory], [eventAction], [eventLabel], [eventValue], [fieldsObject]);
         */
        track: function(category, action, label) {
            // don't track in preview mode
            if (app.pws.isPreview()) return;

            app.ga.track(category, action, label);
/*
            if (typeof ga !== 'undefined') {
                ga('send', 'event', category, action, label);

                if (mode !== 'local') {
                    var gaDebug = {
                        category: category || '',
                        action: action || '',
                        label: label || ''
                    };
                    // console.table(gaDebug);
                }
            }
*/
        },

        /**
         * Analytics pageview
         * ga('send', 'pageview', [page], [fieldsObject]);
         */
        pageView: function(page) {
            // don't track in preview mode
            if (app.pws.isPreview()) return;

            if (typeof ga !== 'undefined') {
                var hash = self.getHash();

                if (!page) {
                    page = decodeURIComponent(window.location.pathname + (hash ? '/'+ hash : ''));
                }

                // Todo: logged in/out, member id, rank
                // ga('set', 'dimension1', 'account-id') // account id
                // ga('set', 'dimension3', 'logged in') // logged in
                ga('set', 'dimension4', app.main.getLanguageCode()); // language
                ga('set', 'dimension5', self.getCountryCode().toUpperCase()); // country
                // ga('set', 'dimension6', 'member-rank') // member-rank
                ga('set', 'page', page);
                ga('send', 'pageview');
                // console.log('page set + pageview: '+ page);
            }
        },

        /**
         * As new cultures are added, some will show their own version of the language selector
         */
        getCultures: function() {
            try {
                // if culture exists but only has 1 language, don't show the switcher
                return cultures[self.getCountryCode()].languages.length > 1 ? cultures[self.getCountryCode()].languages : false;
            } catch(e) {
                return false;
            }
        },

        /**
         * Return the entire countries.json (cultures) object for use in building the custom enrollment country dropdown
         */
        getCountries: function() {
            return cultures;
        },

        /**
         * Compiles a handlebars.js template
         * templateName: the ID of the <script> object that contains an inline template, or the file name of an external template (no extension)
         * data: a json object containing data that will populate the template
         * externalTemplate: if true, will attempt to load an external template file
         * callback: used when loading external templates, function to call when template has loaded
         */
        getTemplate: function(templateName, data, externalTemplate, callback) {
            // always have a data object
            if (data == undefined) {
                data = {};
            }

            // language object will be sent to all templates if present
            if (languageData !== null) {
                data.lang = app.main.getLanguageData();
            }
            data.settings = settings;
            data.sitePath = self.getSitePath();
            data.memberType = app.global.getMemberType();
            data.adminPath = mode == 'local' ? 'http://localhost:8001/' : '/admin/';
            data.hasSubscriptions = app.skava.hasSubscriptions();

            if (externalTemplate === true) {
                // check if template has previously been loaded
                if ($('#template-'+ templateName).length) {
                    // already loaded
                    // console.log('template exists: '+ templateName);
                    if (typeof callback === 'function') {
                        callback(data);
                    }

                } else {
                    // optionally load an external template file
                    $.get('/templates/'+ templateName +'.html'+ cb)
                        .done(function(source) {
                            // console.log('template loaded:', templateName);
                            // don't compile, just add to the DOM and let the calling function process it
                            $('#template-container').append(source);
                            if (typeof callback === 'function') {
                                callback(data);
                            }
                        })
                        .fail(function(e) {
                            // console.log('Failed loading external template: '+ templateName);
                        }
                    );

                }

            } else {
                // default loads an embedded template
                try {
                    var source = $('#template-'+ templateName).html(),
                        template = Handlebars.compile(source);
                    return template(data);

                } catch(err) {
                    console.log('Template error: '+ templateName);
                    console.error(err);
                    var template = Handlebars.compile('<div class="blank-template">Template error: '+ templateName +'</div>');
                    return template(data)
                }
            }
        },

        /**
         * Check for the various ways that custom enrollment might be disabled
         */
        checkCustomEnrollmentEnabled: function(ignoreProfile) {
            // custom enrollment can be disabled a number of ways... let's sort it out
            // - disabled globally in settings.json
            // - disabled by region in [culture-code]/settings.json
            // - never set up at all (null)
            // - set up but disabled in admin by the member
            // - edge case where custom_enrollment_enabled = true in superadmin, but custom_enrollment is null or missing the config data
            // default to the global/regional value (happens in loadLanguageData)

            // if international shopping is disabled, also disable enrollment
            // todo: this may be redundant, but adding just in case
            if (!settings.skavaEnabled && !settings.international_shopping_enabled) {
                return false;
            }

            var enrollmentEnabled = settings.custom_enrollment_enabled;

            if (ignoreProfile) {
                return enrollmentEnabled;
            }

            if (!app.main.getProfile().custom_enrollment) {
                // invalid data, set to false
                //console.log('Custom enrollment is not enabled.');
                //enrollmentEnabled = false;
            }

            // if globally/regionally set to true, the member setting may override it
            if (enrollmentEnabled == true) {
                enrollmentEnabled = app.main.getProfile().custom_enrollment_enabled;
            }

            // if skava is enabled, force enrollment to true
            if (app.main.getSettings().skavaEnabled) {
                enrollmentEnabled = true;
            }

            return enrollmentEnabled;
        },

        /**
         * Scroll to the specified anchor/id
         */
        scrollTo: function(target) {
            // slight delay
            setTimeout(function() {
                $('html,body').stop().animate({
                    'scrollTop': $('#'+ target).offset().top - ($('header').height() + $('.member-info').height())
                }, 900, 'swing', function() {
                    //
                });
            }, 200);
        },

        /**
         * Some YL urls require an uppercase country as part of the culture value
         * In some cases a '-' is used instead of '_'
         */
        getYLCulture: function(delimiter) {
            if (!delimiter) {
                delimiter = '_';
            }

            var pieces = self.getCurrentCulture().split('-');
            return pieces[0] + delimiter + pieces[1].toUpperCase();
        },

        /**
         * Construct the 'become a member' url
         */
        getEnrollURL: function() {
            return 'https://www.youngliving.com/vo/#/signup/new-start?sponsorid='+ profile.member_id +'&enrollerid='+ profile.member_id +'&isocountrycode='+ self.getCountryCode().toUpperCase() +'&culture='+ self.getYLCulture('-') +'&type=member';
        },

        /**
         * Return the current user's profile path - site_path if it has been customized by the user, or username if it hasn't
         */
        getSitePath: function() {
            var path = self.getProfile().site_path ? self.getProfile().site_path : self.getProfile().username;

            if (mode == 'local') {
                path = 'pws.html';
            }

            return path;
        },

        /**
         * Path to admin (primarily used for the signout url)
         */
        getAdminPath: function() {
            return mode == 'local' ? 'http://localhost:8001/' : '/admin/';
        },

        /**
         * Return the query string required when linking out to YL.com
         */
        getMemberString: function() {
            return '?sponsorid='+ profile.member_id +'&enrollerid='+ profile.member_id +'&type=member';
        },

        /**
         * Return the legacy all products url for the member
         */
        getAllProductsURL: function() {
            var filteredCulture = self.getCurrentCulture({ filter: true });
            filteredCulture = filteredCulture.split('-')[0] + '_' + filteredCulture.split('-')[1].toUpperCase();

            return ylURL[mode] + filteredCulture +'/products/'+ self.getMemberString();
        },

        /**
         * Simply adds a click handler to #enroll links to determine whether a custom enrollment package should be reset to default
         */
        setEnrollCheck: function() {
            $('.enroll-check').off('click').on('click', function(e) {
                e.preventDefault();

                if (app.enroll.isCustomPackage()) {
                    app.enroll.reset();
                }

                var href = $(this).attr('href');
                setTimeout(function() {
                    window.location.href = href;
                }, 500);

            });
        },

        /**
         * Helper to replace %s with the provided string.
         */
        strReplace: function(str, repl) {
            var i;
            try {
                if (Array.isArray(repl)) {
                    // check for format %1, %2, etc.
                    // todo: can't use both %s and %1
                    if (str.indexOf('%1') > -1) {
                        for (i=0; i<repl.length; i++) {
                            str = str.replace('%'+ (i+1), repl[i]);
                        }

                    } else {
                        for (i=0; i<repl.length; i++) {
                            str = str.replace(/%s/, repl[i]);
                        }
                    }

                } else {
                    str = str.replace(/%s/g, repl);
                }
            } catch(e) {
                str = '';
            }
            return str;
        },

        /**
         * Helper function to sort an array of objects by chosen key
         */
        sort: function(arr, key, dir) {
            try {
                if (dir == 'desc') {
                    arr.sort(function(a, b) {
                        if (!a[key] == undefined) {
                            a[key] = -1;
                        }

                        if (!b[key] == undefined) {
                            b[key] = -1;
                        }
                        return b[key].toString().toLowerCase().localeCompare(a[key].toString().toLowerCase());
                    });

                } else {
                    arr.sort(function(a, b) {
                        if (a[key] == undefined) {
                            a[key] = 99;
                        }

                        if (b[key] == undefined) {
                            b[key] = 99;
                        }
                        return a[key].toString().toLowerCase().localeCompare(b[key].toString().toLowerCase());
                    });
                }
            } catch (err) {
                console.log('sort failed', arr, key);
            }
        },

        /**
         * Merge two arrays, removing duplicates
         */
        merge: function(a1, a2) {
            var hash = {},
            arr = [],
            i;

            for (i = 0; i < a1.length; i++) {
                if (hash[a1[i]] !== true) {
                    hash[a1[i]] = true;
                    arr[arr.length] = a1[i];
                }
            }

            for (i = 0; i < a2.length; i++) {
                if (hash[a2[i]] !== true) {
                    hash[a2[i]] = true;
                    arr[arr.length] = a2[i];
                }
            }

            return arr;
        },

        /**
         * Search an object and return values for matching keys
         */
        recursiveSearch: function(obj, searchKey, results) {
            var r = results ? results : [];

            Object.keys(obj).forEach(function(key) {
                var value = obj[key];

                if (key === searchKey && typeof value !== 'object') {
                    r.push(value);

                } else if (typeof value === 'object') {
                    self.recursiveSearch(value, searchKey, r);
                }
            });

           return r;
        },

        /**
         * Reset cart/enrollment, clear cookies
         */
        resetShopping: function(callback) {
            // only for skava
            if (!app.main.getSettings().skavaEnabled) {
                return;
            }

            // enable below to always delete cart
            // if (!callback) {
            //     callback = function() {};
            // }

            app.enroll.reset();
            app.cart.clear();

            if (callback) {
                console.log('delete cart...');
                app.skava.deleteCart(function() {
                    console.log('clear cookies');
                    app.cookie.clear('c_yl_skava');
                    app.cookie.clear('myyl_sid');
                    callback();
                });

            } else {
                // app.cookie.clear('c_yl_skava');
                app.cookie.clear('myyl_sid');
            }
        },

        /**
         * Check if all products are out of stock in case of skava error
         */
        checkInStock: function(items) {
            // if skava isn't enabled, this isn't required
            if (!app.main.getSettings().skavaEnabled) {
                return true;
            }

            var i = items.length,
                outOfStockCount = 0,
                percent = 0,
                // forceInStock = app.cookie.get('myyl_force_in_stock');
                forceInStock = true;

            // if (forceInStock) {
            //     console.log('forcing all products in_stock=true');
            // }

            // in case of a skava issue that causes all products to be out of stock
            while (i--) {
                // can be overridden by cookie, for testing only
                // if (forceInStock) {
                //     items[i].in_stock = true;
                // }

                if (!items[i].in_stock) {
                    outOfStockCount++;
                }
            }

            percent = Math.round(outOfStockCount / items.length * 100);
            // console.log(percent +'% out of stock');

            if (percent > 75) {

                if (mode == 'live') {
                    // auto trigger in stock when threshold reached
                    console.log('forcing all products in_stock=true');
                    i = items.length;

                    while (i--) {
                        if (forceInStock) {
                            items[i].in_stock = true;
                        }
                    }

                } else {
                    app.main.showCriticalError(percent +'% of products are out of stock.');
                    return false;
                }
            }

            return true;
        },

        /**
         * If a critical service is unavailable, show the site down message
         */
        showCriticalError: function(reason) {
            if (mode == 'live') {
                reason = null;
            }

            app.page.hideLoader();
            app.main.getTemplate('critical-error', {}, true, function() {
                $('#page').empty().html(app.main.getTemplate('critical-error', { reason: reason }));
                self.hideHeaderRight(true);;
            });
        },

        /**
         * For testing only. Will replace all language key content with the key name
         */
        showLangKeys: function(bool) {
            if (bool === true) {
                app.cookie.set(true, 'myyl_show_lang_keys', 1);

            } else {
                app.cookie.clear('myyl_show_lang_keys');
            }

            // clear the hash
            window.history.pushState('', document.title, window.location.pathname);
            window.location.reload();
        },

        /**
         * Utility function to clone a json object
         */
        clone: function(obj) {
            if (typeof obj !== 'object') {
                return obj;
            }

            return JSON.parse(JSON.stringify(obj));
        },

        getShareParam: function() {
            var urlSearchParams = new URLSearchParams(window.location.search);
            var params = Object.fromEntries(urlSearchParams.entries());

            if (params && params.share) {
                return params.share;

            } else {
                return false;
            }
        }
    };

    return self;
}());


/**
 * Handles loading, opening and closing the modal view on top of the current page
 * Optional onClose function passed to load will execute when modal closes
 */
app.modal = (function() {
    'use strict';
    var $container,
        onClose = function() {},
        onClose2 = function() {},
        closeCallback = function() {},
        self = {

        init: function(container) {
            if (container) {
                $container = $(container);

            } else {
                $container = $('#modal');
            }
        },

        load: function(template, data, onCloseFunction) {
            $('.modal-content', $container).empty().html(app.main.getTemplate(template, data));
            self.open();

            if (typeof onCloseFunction === 'function') {
                if ($container.attr('id') === 'modal') {
                    onClose = onCloseFunction;

                } else {
                    onClose2 = onCloseFunction;
                }
            }
        },

        open: function() {
            $('body').addClass('no-scroll');
            $container.addClass('is-active');
            $('.modal-bg', $container).on('click', self.close);
            $('.close, .btn-close', $container).on('click', self.close);
            app.page.addClickHandler('#modal [data-page]');
            $(window).off('keyup', self.keyUpHandler).on('keyup', self.keyUpHandler);
        },

        close: function() {
            $container.removeClass('is-active');
            $('.modal-content', $container).empty();
            $('.modal-bg', $container).off('click', self.close);

            // only default modal
            if ($container.attr('id') === 'modal') {
                $('body').removeClass('no-scroll');
                $(window).off('keyup', self.keyUpHandler);
                onClose();

            } else {
                onClose2();
            }

            closeCallback();
        },

        setCloseCallback: function(callback) {
            if (typeof callback !== 'function') {
                return;
            }

            closeCallback = callback;
        },

        keyUpHandler: function(e) {
            // esc closes modal
            if (e.keyCode == 27) {
                self.close();
            }
        }
    };
    return self;
})();



/**
 * About page view
 */
app.page.about = (function() {
    "use strict";
    var self = {

        init: function() {
            app.page.load('json/'+ app.main.getCurrentCulture() +'/about.json', self);
        },

        render: function(data) {
            data.profile = app.main.getProfile();
            $('#page').html(app.main.getTemplate('page-about', data));
        }
    };

    return self;
}());




/**
 * Member Benefits page view
 */
app.page.benefits = (function() {
    "use strict";
    var self = {

        init: function() {
            app.page.load('json/'+ app.main.getCurrentCulture() +'/benefits.json', self);
        },

        render: function(data) {
            data.profile = app.main.getProfile();
            data.enrollmentEnabled = app.main.checkCustomEnrollmentEnabled();
            data.become_member_url = app.main.getEnrollURL();
            console.log(data.become_member_url);

            $('#page').html(app.main.getTemplate('page-benefits', data));
            app.main.setEnrollCheck();
        }
    };

    return self;
}());




/**
 * Impressum page for german markets
 */
app.page.impressum = (function() {
    "use strict";
    var self = {

        init: function() {
            app.page.load('json/de-de/impressum.json', self);
        },

        render: function(data) {
            $('#page').html(app.main.getTemplate('page-impressum', data));
        }
    };

    return self;
}());





/**
 * Generic error view
 */
app.page.error = (function() {
    "use strict";
    var self = {

        init: function() {
            app.page.postLoad({
                page: 'error',
                title: app.main.lang('error_404_pws')
            }, self);
        },

        render: function(data) {
            $('#page').html(app.main.getTemplate('page-error', data));
            $('#btn-home').on('click', function(e) {
                e.preventDefault();
                window.location.replace(location.origin +'/'+ app.main.getSitePath());
            });
        }
    };

    return self;
}());




/**
 * All about cookies page view
 */
app.page.cookies = (function() {
    "use strict";
    var self = {

        init: function() {
            app.page.load('json/'+ app.main.getCurrentCulture() +'/page-cookies.json', self);
        },

        render: function(data) {
            app.main.getTemplate('page-cookies', {}, true, function() {
                $('#page').html(app.main.getTemplate('page-cookies', data));
            });
        }
    };

    return self;
}());






/**
 * Sample of a Google Sheets generated page
 */
app.page.sample = (function() {
    "use strict";
    var self = {

        init: function() {
            app.page.load('json/'+ app.main.getCurrentCulture() +'/page-sample.json', self);
        },

        render: function(data) {
            app.main.getTemplate('page-sample', {}, true, function() {
                $('#page').html(app.main.getTemplate('page-sample', data));
            });
        }
    };

    return self;
}());






/**
 * All about privacy policy page view
 */
app.page.privacy = (function() {
    "use strict";
    var self = {

        init: function() {
            app.page.load('json/'+ app.main.getCurrentCulture() +'/privacy.json', self);
        },

        render: function(data) {
            app.main.getTemplate('page-privacy', {}, true, function() {
                $('#page').html(app.main.getTemplate('page-privacy', data));
            });
        }
    };

    return self;
}());





/**
 * ER Learn More page
 */
app.page.learnmore = (function() {
    "use strict";
    var self = {

        init: function() {
            app.page.load('json/'+ app.main.getCurrentCulture() +'/page-er-learn-more.json', self, function() {
                //window.location = 'https://www.youngliving.com/'+ app.main.getYLCulture() +'/opportunity/essential-rewards';
                app.page.error.init();
            });
        },

        render: function(data) {
            app.main.getTemplate('page-er-learn-more', {}, true, function() {
                $('#page').html(app.main.getTemplate('page-er-learn-more', data));
                $('.fitvid').fitVids();
            });
        }
    };

    return self;
}());



/**
 * Helper for products and enrollment pages common functions (in progress)
 */
app.products = (function() {
    "use strict";
    var self = {

        init: function() {
            // not used, perhaps in the future this will load and process products for both product and enrollment modules
        },

        // addOutOfStock - boolean, when true it will add variants whether in stock or not (pws cart only)
        groupVariants: function(products, addOutOfStock) {
            // non-skava removes out of stock items
            if (!app.main.getSettings().skavaEnabled) {
                addOutOfStock = false;
            }

            var i = products.length;

            // -------- THIS IS TO SHOEHORN VALUES INTO V2 PRODUCTS.JSON -------- //
            while (i--) {
                // force in_stock
                // if (['local', 'dev'].includes(mode)) {
                //     products[i].in_stock = true;
                // }

                // bad data if part_number is null
                if (!products[i].part_number) {
                    // console.log('bad part_number');
                    products[i].part_number = '';
                }

                // bad data if variant is null
                if (!products[i].variant) {
                    products[i].variant = ' ';
                }

                if (products[i].price) {
                    // remove products with a 0 price
                    if (products[i].price == '0.00') {
                        // console.log('removing 0 price '+ products[i].sku_id);
                        products.splice(i, 1);
                        continue;
                    }

                    products[i].price =
                    products[i].wholesale_price =
                    products[i].wholesale_price_with_tax =
                    products[i].retail_price =
                    // products[i].retail_price_with_tax = parseFloat(products[i].price) * 100;
                    products[i].retail_price_with_tax = app.global.convert(products[i].price);
                }

                if (products[i].price_after_discount) {
                    // products[i].price_after_discount = parseFloat(products[i].price_after_discount) * 100;
                    products[i].price_after_discount = app.global.convert(products[i].price_after_discount);
                }

                if (products[i].starter_kit || (products[i].price == products[i].price_after_discount) || products[i].loyalty) {
                    delete products[i].price_after_discount;
                }

                if (products[i].loyalty) {
                    products[i].bwm = true;
                    products[i].type = 'subscribe';
                }

                if (products[i].point_value) {
                    products[i].point_value = parseFloat(products[i].point_value) * 100;
                    products[i].distributor_point_value = products[i].point_value;
                }

                if (products[i].sku_id) {
                    products[i].item_id = parseInt(products[i].part_number, 10);
                }

                // if (products[i].starter_kit) {
                //     products[i].enrollment = products[i].starter_kit;
                // }

                // special case for a specific AU starter kit
                if (products[i].part_number == '36990') {
                    products[i].retail_price_with_tax =
                    products[i].wholesale_price_with_tax = products[i].retail_price;
                }

                // Remove DSKU products that are out of stock. We don't want to display them.
                if (self.isOnSale(products[i]) && products[i].in_stock == false) {
                    //console.log('removing out of stock '+ products[i].part_number);
                    products.splice(i, 1);

                } else {
                    if (!addOutOfStock) {
                        if (products[i].in_stock == false) {
                            products.splice(i, 1);
                        }
                    }
                }

                // add quality, format and size attributes to image_url
                if (app.main.getSettings().skavaEnabled && products[i].image_url) {
                    products[i].image_url += '?q=75&fm=jpg&w=1080&h=1080';
                }
            }

            // group items with duplicate product_id
            products.forEach(function(product) {
                var search = [];

                // clear empty variant strings
                if (product.variant !== product.variant.trim()) {
                    product.variant = "";
                }

                products.forEach(function(item) {
                    if (item.product_id == product.product_id) {
                        search.push(item);
                    }
                });

                if (search.length > 1) {
                    product.variants = [];

                    search.forEach(function(child) {
                        // add custom on_sale flag to parent product if any variants are DSKU
                        if (self.isOnSale(child)) {
                            product.on_sale = true;
                        }

                        // only add variants that are in stock (except for the PWS cart)
                        if (child.in_stock || addOutOfStock === true) {
                            if (child.variant) {
                                var variantProps = {
                                    description: child.description,
                                    distributor_point_value: child.distributor_point_value,
                                    enrollment: child.enrollment,
                                    essential_rewards: child.essential_rewards,
                                    image_url: child.image_url,
                                    in_stock: child.in_stock,
                                    item_id: child.item_id,
                                    name: child.name,
                                    part_number: child.part_number,
                                    product_id: child.product_id,
                                    retail_point_value: child.retail_point_value,
                                    retail_price: child.retail_price,
                                    retail_price_with_tax: child.retail_price_with_tax,
                                    url: child.url,
                                    variant: child.variant,
                                    wholesale_price: child.wholesale_price,
                                    wholesale_price_with_tax: child.wholesale_price_with_tax,
                                    default: child.default,
                                    subscription: child.subscription
                                };

                                // -------- THIS IS TO SHOEHORN VALUES INTO V2 PRODUCTS.JSON -------- //
                                if (child.point_value) {
                                    variantProps.point_value = child.point_value;
                                    variantProps.distributor_point_value = child.point_value;
                                }

                                if (child.price) {
                                    // variantProps.price =
                                    // variantProps.retail_price =
                                    // variantProps.retail_price_with_tax =
                                    // variantProps.wholesale_price =
                                    // variantProps.wholesale_price_with_tax = parseFloat(child.origPrice) * 100;
                                    variantProps.price = child.price;
                                }

                                if (child.price_after_discount) {
                                    variantProps.price_after_discount = child.price_after_discount;
                                }

                                if (child.sku_id) {
                                    variantProps.item_id = parseInt(child.part_number, 10);
                                }

                                product.variants.push(variantProps);

                                if (child.subscription) {
                                    product.can_subscribe = true;
                                }

                            } else {
                                //console.log(child.name +' variant is null. Skipped');
                            }
                        } else {
                            //console.log(child.part_number +' variant is not in stock. Skipped.');
                        }
                    });

                    // sort variants alphabetically by variant, unless it's on sale then sort by part number
                    product.variants.sort(function(a, b) {
                        if (a.default) {
                            return -1;
                        } else if (b.default) {
                            return 1;
                        }

                        if (product.on_sale == true) {
                            // DESC sort by part_number
                            return b.part_number.localeCompare(a.part_number);
                        }
                        // ASC alphabetically
                        /*
                        if (!a.variant) {
                            a.variant = '';
                        }
                        if (!b.variant) {
                            b.variant = '';
                        }
                        */
                        return a.variant.toLowerCase().localeCompare(b.variant.toLowerCase());
                    });

                    // When sorting variants, this will pop the default variant to the top of the list making it the first available be default
                    // Uses a hacky way of country+language searches

                    var match = '',
                        found = false;

                    product.variants.forEach(function(item, i) {
                        // skip the first one
                        if (i > 0 && item.variant) {
                            // remove non-alphanumeric characters and set to lower case for consistent searching
                            // i.e. (EU Plug) and (EU - Plug) both become euplug
                            match = item.variant.replace(/[^a-z0-9]/gi, '').toLowerCase();
                            found = false;

                            switch (app.main.getCurrentCulture()) {
                                case 'en-us':
                                    if (match.indexOf('english') > -1) {
                                        found = true;
                                    }
                                break;

                                case 'es-us':
                                    if (match.indexOf('spanish') > -1) {
                                        found = true;
                                    }
                                break;

                                case 'en-eu':
                                    if (match.indexOf('euplug') > -1) {
                                        found = true;
                                    }
                                break;

                                case 'en-gb':
                                    if (match.indexOf('ukplug') > -1) {
                                        found = true;
                                    }
                                break;
                            }

                            if (found === false) {
                                match = item.variant.toLowerCase();

                                if (match.indexOf('('+ app.main.getCountryCode() +')') > -1) {
                                    found = true;
                                }
                            }

                            if (found) {
                                product.variants.splice(i, 1);
                                product.variants.unshift(item);
                            }
                        }
                    });

                    // remove variants array if it has 1 or fewer items
                    if (product.variants.length < 2) {
                        delete product.variants;
                    }
                }
            });

            app.main.sort(products, 'name');
        },

        /**
         * Check if the slected product is 'on sale' - DSKU - it has a D at the end of its part_number...
         */
        isOnSale: function(product) {
            var onSale = (product.on_sale == true || product.part_number.slice(-1) === 'D') ? true : false;
            if (onSale) {
                //console.log(product.name +' part #'+ product.part_number +' is on sale');
            }
            return onSale;
        },

        // mark products as subscribed
        // type is pws or enroll, pws default
        setSubscribed: function(products, type) {
            if (!type) {
                type = 'pws';
            }

            var list = app.skava.getSubscriptionList();

            if (products && typeof list == 'object') {
                list.forEach(function(product_id) {
                    var product = app[type].getProductByID(product_id);

                    if (product) {
                        product.isSubscribed = true;
                        console.log('isSubscribed: '+ product.name);
                    }
                });
            }
        },

        /**
         * For testing only. This will set all product.in_stock to true or false
         */
        setInStock: function(bool) {
            if (bool === true) {
                app.cookie.set(true, 'myyl_force_in_stock', 1);

            } else {
                app.cookie.clear('myyl_force_in_stock');
            }
        },

        /**
         * Special case for Australia
         */
        parseAuProducts: function(module) {
            if (!module) {
                module = 'pws';
            }

            if (app.main.getCountryCode() == 'au') {
                var priceUpdates = [
                    {
                        "part_number": "3044560",
                        "wholesale_price": 19610,
                        "retail_price": 25805,
                        "wholesale_price_with_tax": 19610,
                        "retail_price_with_tax": 25805
                    },
                    {
                        "part_number": "36990",
                        "wholesale_price": 24790,
                        "retail_price": 24790,
                        "wholesale_price_with_tax": 25130,
                        "retail_price_with_tax": 27269
                    },
                    {
                        "part_number": "22159",
                        "wholesale_price": 25700,
                        "retail_price": 25700,
                        "wholesale_price_with_tax": 27700,
                        "retail_price_with_tax": 28270
                    },
                    {
                        "part_number": "24702",
                        "wholesale_price": 23500,
                        "retail_price": 23500,
                        "wholesale_price_with_tax": 24700,
                        "retail_price_with_tax": 25850
                    },
                    {
                        "part_number": "489702",
                        "wholesale_price": 17500,
                        "retail_price": 17500,
                        "wholesale_price_with_tax": 17700,
                        "retail_price_with_tax": 19250
                    },
                    {
                        "part_number": "636002",
                        "wholesale_price": 3595,
                        "retail_price": 4730,
                        "wholesale_price_with_tax": 3595,
                        "retail_price_with_tax": 4730
                    },
                    {
                        "part_number": "3042560",
                        "wholesale_price": 10895,
                        "retail_price": 14335,
                        "wholesale_price_with_tax": 10895,
                        "retail_price_with_tax": 14335
                    },
                    {
                        "part_number": "3525560",
                        "wholesale_price": 13100,
                        "retail_price": 17235,
                        "wholesale_price_with_tax": 13100,
                        "retail_price_with_tax": 17235
                    },
                    {
                        "part_number": "489302",
                        "wholesale_price": 21500,
                        "retail_price": 21500,
                        "wholesale_price_with_tax": 21500,
                        "retail_price_with_tax": 21500
                    },
                    {
                        "part_number": "37666",
                        "wholesale_price": 29295,
                        "retail_price": 29295,
                        "wholesale_price_with_tax": 29295,
                        "retail_price_with_tax": 32224
                    }
                ];

                priceUpdates.forEach(function(newItem) {
                    var item = app[module].getProductByID(newItem.part_number, 'part_number');
                    if (item) {
                        item.wholesale_price = newItem.wholesale_price;
                        item.retail_price = newItem.retail_price;
                        item.wholesale_price_with_tax = newItem.wholesale_price_with_tax;
                        item.retail_price_with_tax = newItem.retail_price_with_tax;
                    }
                });
            }
        }
    };

    return self;
}());
